import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 py-3 md:py-4 flex items-center justify-between">
        <Link
          to="/"
          className={`font-heading text-xl md:text-2xl font-bold tracking-tight transition-colors ${
            scrolled || !isHome ? 'text-primary-600' : 'text-white'
          }`}
        >
          吃瓜爆料
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              scrolled || !isHome
                ? 'text-foreground-700 hover:text-primary-600'
                : 'text-white/90 hover:text-white'
            } ${location.pathname === '/' ? 'font-semibold' : ''}`}
          >
            首页
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                scrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-600'
                  : 'text-white/90 hover:text-white'
              } ${location.pathname === `/category/${cat.slug}` ? 'font-semibold' : ''}`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              scrolled || !isHome
                ? 'text-foreground-700 hover:text-primary-600'
                : 'text-white/90 hover:text-white'
            } ${location.pathname === '/about' ? 'font-semibold' : ''}`}
          >
            关于我们
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-8 h-8 flex items-center justify-center transition-colors ${
            scrolled || !isHome ? 'text-foreground-800' : 'text-white'
          }`}
          aria-label="菜单"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`} />
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-b border-background-200/70 px-4 pb-4">
          <Link
            to="/"
            className="block py-3 text-sm font-medium text-foreground-700 border-b border-background-200/50"
          >
            首页
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="block py-3 text-sm font-medium text-foreground-700 border-b border-background-200/50"
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className="block py-3 text-sm font-medium text-foreground-700"
          >
            关于我们
          </Link>
        </div>
      )}
    </header>
  );
}